import {
  VStack,
  responsive,
  getCdnImageSrc,
  Image,
  NextLink,
  HStack,
} from "goi_common";
import { Box, Stack } from "@chakra-ui/react";

export default function Content() {
  return (
    <VStack width="100%" alignItems="center">
      <VStack
        maxWidth={`${1200}px`}
        width="100%"
        css={responsive({ padding: { base: "0", lg: "0px 20px" } })}
      >
        <ContentMainHeroSection />
        <ContentMainFuneralGuideSection />
      </VStack>
    </VStack>
  );
}

function ContentMainHeroSection() {
  return (
    <VStack
      width="100%"
      css={responsive({
        background: `url(${getCdnImageSrc("direct/content/main-hero.png")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: { base: 0, lg: "30px" },
        padding: { base: "64px 24px 57px", lg: "120px 60px 120px" },
        marginTop: { base: 0, lg: "10px" },
      })}
    >
      <Box as="p" className="head_24_eb md_head_42_eb white">
        고이BIZ 고객사 도입사례
      </Box>
    </VStack>
  );
}

function ContentMainFuneralGuideSection() {
  return (
    <Stack
      width="100%"
      css={responsive({
        padding: { base: "16px 24px 60px", lg: "30px 0 60px" },
      })}
    >
      <HStack justifyContent="space-between" alignItems="flex-start">
        <h2
          className="gray900 subtitle_18_b md_head_32_sb"
          css={responsive({ marginBottom: { base: "0px", md: "40px" } })}
        >
          인터뷰
        </h2>
      </HStack>

      <Stack css={responsive({ gap: { base: "24px", lg: "40px" } })}>
        <FuneralGuideCard
          tag="무인양품(MUJI) 고이BIZ 도입 인터뷰"
          title="‘고이는 사명감을 갖고 일한다’는 게 느껴졌어요."
          description="인터뷰를 요약하자면 아래와 같아요. 예산과 형평성 사이에서 고민하던 복지 제도, 비용 부담 없이 희망자에게 제공하는 형태로 유연하게 도입. / 디테일한 소개내용 및 문의사항에 대한 빠르고 세심한 커뮤니케이션으로 실무자 부담 감소. / 단순 제휴가 아닌 후기 평점 4.9점 등 실제 사용자 데이터 제공으로 내부 설득 용이."
          date="25-05-13"
          path="muji"
          imgSrc="b2b/content/muji1.png"
        />
        <FuneralGuideCard
          tag="KB 핀테크 고이BIZ 도입 인터뷰"
          title="일단 도입하고 보는 것 말고, 잘 검증하고 확신을 가진 상태에서 선택하고 싶었어요."
          description="인터뷰를 요약하자면 아래와 같아요. 구성원의 마음에 닿는 복지를 만든다는 생각으로, '경조 복지 선택의 기준', 고이의 대표 장례지도사(=CEO)와의 깊은 대화로 검증했던 '고이 서비스의 진정성' 최종 도입결정은 유연하면서도 현실적으로!! (조직 예산, 규모, 실행 가능성 등 종합적 검증)"
          date="25-06-16"
          path="kbpin"
        />
      </Stack>
    </Stack>
  );
}

function FuneralGuideCard({
  tag,
  title,
  description,
  date,
  path,
  imgSrc,
}: {
  tag: string;
  title: string;
  description: string;
  date: string;
  path: string;
  imgSrc?: string;
}) {
  return (
    <NextLink
      href={`/content/${path}/`}
      css={{ width: "100%" }}
      event={{
        newGtm: { path: "content", trigger_and_target: "CTA_uv_guidebook" },
      }}
    >
      <Stack
        css={responsive({
          flexDirection: { base: "column-reverse", md: "row" },
          width: "100%",
          gap: { base: "16px", md: "40px" },
        })}
      >
        <VStack gap="4px">
          <Box className="body_14_m md_subtitle_16_sb gray500">{tag}</Box>
          <Box className="subtitle_16_sb md_subtitle_21_b gray800">{title}</Box>

          <Box
            className="md_body_14_l gray500"
            padding="4px 0 4px"
            css={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {description}
          </Box>

          <Box className="caption_12_r md_body_14_r gray600">{date}</Box>
        </VStack>
        <Box
          css={responsive({
            width: { base: "100%", md: "266px" },
            height: { base: "100%", md: "180px" },
            maxHeight: { base: "180px" },
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          })}
          flexShrink={0}
        >
          <Image
            src={getCdnImageSrc(imgSrc || `direct/content/sn-1.png`)}
            width="100%"
            alt=""
            css={{
              borderRadius: "20px",
              overflow: "hidden",
            }}
          />
        </Box>
      </Stack>
    </NextLink>
  );
}
